import { render, staticRenderFns } from "./InfoPromosTime.vue?vue&type=template&id=60b737a8&scoped=true"
import script from "./InfoPromosTime.vue?vue&type=script&lang=js"
export * from "./InfoPromosTime.vue?vue&type=script&lang=js"
import style0 from "./InfoPromosTime.vue?vue&type=style&index=0&id=60b737a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b737a8",
  null
  
)

export default component.exports